export default "__VITE_ASSET__Du1l$bcj__"